module.exports = __webpack_public_path__ + "img/remove_the_2_bottom2.24fb2e25.png";